import axios from "axios";

import { parseAxiosError } from "./parseAxiosError";
import { RequestRefreshToken } from "./request-refresh-token";
import { BaseUrl } from "./api";
import { GetLocalStorage, SetLocalStorage } from "../utils/local-storage";

const commonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const axiosInstance = axios.create({
  baseURL: BaseUrl,
  timeout: 900000,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async (error) => {
    const originalRequest = error?.config;
    if (error.response.status === 400) {
      const { data } = error?.response;
      if (data?.errors[0]) {
        data?.errors?.map((x: any) => console.log(error(x)));
        console.log(data.errors[0]);
      }
    }
    originalRequest._retry = originalRequest._retry ?? 1;
    if (error.response.status === 401 && originalRequest._retry <= 2) {
      originalRequest._retry++;
      const getData: any = await RequestRefreshToken();
      const newToken: any = getData?.result;
      SetLocalStorage("loginData", newToken);
      if (newToken) {
        // Update the authorization header with the new access token
        originalRequest.headers.Authorization = `Bearer ${newToken.jwtToken}`;
        return axiosInstance(originalRequest);
      }
      return Promise.reject(error);
    }
    if (error.response.status === 404) {
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      return Promise.reject(error);

      // return Promise.reject(error);
    }
  }
);

export const GET = async (url: string, params?: { [name: string]: string }) => {
  // const authorization = token ? "Bearer" + token : "";
  // const authorization = token ? token : "";

  let tempData = GetLocalStorage("loginData");
  return new Promise(function (resolve, reject) {
    axiosInstance({
      params,
      method: "get",
      url: url,
      headers: {
        ...commonHeaders,
        Authorization: tempData?.jwtToken,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(async (e) => {
        const error = await parseAxiosError(e);
        reject(error);
      });
  });
};

export const POST = async (url: string, data?: any) => {
  // const authorization = token ? "Bearer" + token : "";
  let tempData = GetLocalStorage("loginData");
  // const authorization = `Bearer ${tempData?.jwtToken}`;
  // const authorization = token ? `Bearer ${token}` : "";POST

  return new Promise(function (resolve, reject) {
    axiosInstance({
      data,
      method: "post",
      url: url,
      headers: {
        ...commonHeaders,
        Authorization: tempData?.jwtToken,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(async (e) => {
        const error = await parseAxiosError(e);
        reject(error);
      });
  });
};

export const PUT = async (url: string, data?: any) => {
  let tempData = GetLocalStorage("loginData");
  // const authorization = tempData?.jwtToken
  //   ? `Bearer ${tempData?.jwtToken}`
  //   : "";

  // const authorization = token ? "Bearer" + token : "";
  // const authorization = token ? `Bearer ${token}` : "";

  return new Promise(function (resolve, reject) {
    axiosInstance({
      data,
      method: "put",
      url: url,
      headers: {
        ...commonHeaders,
        // Authorization: authorization,
        Authorization: tempData?.jwtToken,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(async (e) => {
        const error = await parseAxiosError(e);
        reject(error);
      });
  });
  // const headers = {
  //   "Content-Type": "application/json", // Adjust content type based on your API requirements
  //   Authorization: authorization, // Include any authorization token if needed
  // };
  // return new Promise(function (resolve, reject) {
  //   axios
  //     .put(url, data, { headers })
  //     .then((response) => {
  //       console.log("response", response);
  //       // Handle the response
  //       resolve(response.data);
  //     })
  //     .catch(async (e) => {
  //       const error = await parseAxiosError(e);
  //       reject(error);
  //     });
  // });
};

export const DELETE = async (url: string) => {
  let tempData = GetLocalStorage("loginData");

  return new Promise(function (resolve, reject) {
    axiosInstance({
      method: "delete",
      url: url,
      headers: {
        ...commonHeaders,
        Authorization: tempData?.jwtToken,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(async (e) => {
        const error = await parseAxiosError(e);
        reject(error);
      });
  });
};
